/**
 * Reglas del paso de documentos de flete (SP-221).
 *
 * Viven aquí y no dentro de la pantalla para que la prueba mida la regla real y
 * no una copia: el servidor valida lo mismo, así que si esto se relaja de un
 * lado el otro sigue cortando.
 */
export interface DocumentosDeFleteElegidos {
  cartaPorteAplica: boolean
  cartaPorteXml?: File | null
  cartaPortePdf?: File | null
  remisionFirmada?: File | null
  hojaEntregas?: File | null
}

/**
 * El paso queda resuelto cuando la Carta Porte está definida —con sus dos
 * archivos si aplica, o declarada como que no aplica— y hay al menos un soporte
 * firmado. Para quien no es de Fletes no hay paso que resolver.
 */
export const pasoDeFleteResuelto = (
  esFletes: boolean,
  elegidos: DocumentosDeFleteElegidos,
): boolean => {
  if (!esFletes) return true

  const cartaPorteLista =
    !elegidos.cartaPorteAplica ||
    Boolean(elegidos.cartaPorteXml && elegidos.cartaPortePdf)
  const traeSoporte = Boolean(elegidos.remisionFirmada || elegidos.hojaEntregas)

  return cartaPorteLista && traeSoporte
}
